import React, { ReactNode, useState } from "react";
import { Button, Group, Stepper as MantineStepper } from "@mantine/core";
import "./stepper.css";
export interface StepperProps {
  data: {
    label: string;
    description?: string;
    component: ReactNode;
    onNext: () => Promise<void>;
  }[];
  completed?: ReactNode;
  variant?: "default" | "textDown";
  page: number;
  setPage: (page: number) => void;
}

export const Stepper = ({ ...props }: StepperProps) => {
  const isCompletedOrLastStep =
    (props.completed && props.data.length === props.page) ||
    (!props.completed && props.data.length - 1 === props.page);

  const nextStep = async () => {
    if (props.data[props.page].onNext && !isCompletedOrLastStep) {
      await props.data[props.page].onNext();
    }
  };
  const prevStep = () =>
    props.setPage(props.page > 0 ? props.page - 1 : props.page);

  return (
    <>
      <MantineStepper
        color="#3C61E3"
        active={props.page}
        classNames={
          props.variant === "textDown"
            ? {
                separator: "variant-separator",
                steps: "variant-steps",
                step: "variant-step",
                stepBody: "variant-step-body",
              }
            : undefined
        }
      >
        {props.data.map((step, index) => (
          <MantineStepper.Step
            key={index}
            label={step.label}
            description={step.description}
          >
            {step.component}
          </MantineStepper.Step>
        ))}
        <MantineStepper.Completed>{props.completed}</MantineStepper.Completed>
      </MantineStepper>

      <Group
        justify="space-between"
        mt="xl"
      >
        {props.page > 0 && (
          <Button
            color="#3C61E3"
            variant="outline"
            onClick={prevStep}
          >
            Précédent
          </Button>
        )}
        {props.page === 0 && <div></div>}
        {isCompletedOrLastStep && (
          <Button
            color="green"
            type="submit"
          >
            Valider ma commande
          </Button>
        )}
        {!isCompletedOrLastStep && (
          <Button
            color="#3C61E3"
            onClick={nextStep}
            type="button"
          >
            Suivant
          </Button>
        )}
      </Group>
    </>
  );
};
